import { raceGenderConfigs } from "../../Common/Constants/EEPlanRaceGenderPairsGraphHeadings";

export enum ChartType {
    AddNew,
    EmployeeHeadCountChart1DoubleColumnChart,
    EmployeeHeadCount1PieChart,
    RecruitmentHeadcountChart,
    PromotionHeadcountChart,
    TerminationHeadcountChart,
    IncomeDifferentialGraph,
    IncomeDifferential1Analysis,
    IncomeDifferential2Analysis,
    WSPCostAndHeadcountOFOCodeChart,
    ATRCostAndHeadcountOFOCodeChart,
    WSPCostAndHeadcountTrainingChart,
    ATRCostAndHeadcountTrainingChart,
    WSPCostAndInterventionChart,
    ATRCostAndInterventionChart,
    WorkforceProfileOfoMajorGroupSummary,
    EEPlanTrackingChartAfricanMale,
    EEPlanTrackingChartAricanFemale,
    EEPlanTrackingChartColouredMale,
    EEPlanTrackingChartColouredFemale,
    EEPlanTrackingChartIndianMale,
    EEPlanTrackingChartIndianFemale,
    EEPlanTrackingChartWhiteMale,
    EEPlanTrackingChartWhiteFemale,
    EEPlanTrackingChartNonRSAMale,
    EEPlanTrackingChartNonRSAFemale
}

export const getFriendlyNameForChartType = (chartType: ChartType, scorecardTypeId?: string, scorecardYear?: number): string => {
    switch (chartType) {
        case ChartType.AddNew:
            return 'Add chart/table';
        case ChartType.EmployeeHeadCountChart1DoubleColumnChart:
            return 'Headcount Per Race And Occupational Level';
        case ChartType.EmployeeHeadCount1PieChart:
            return 'Headcount Per Race And  Occupational Level';
        case ChartType.RecruitmentHeadcountChart:
            return 'Recruitment Headcount';
        case ChartType.PromotionHeadcountChart:
            return 'Promotion Headcount';
        case ChartType.TerminationHeadcountChart:
            return 'Termination Headcount';
        case ChartType.IncomeDifferentialGraph:
            return 'Income Differentials';
        case ChartType.IncomeDifferential1Analysis:
            return 'Income Differential Analysis';
        case ChartType.IncomeDifferential2Analysis:
            return 'Income Differential Analysis';
        case ChartType.WSPCostAndHeadcountOFOCodeChart:
            return `WSP ${ scorecardYear }: Cost and Headcount per OFO Code`;
        case ChartType.ATRCostAndHeadcountOFOCodeChart:
            return `ATR ${ scorecardYear ? scorecardYear - 1 : '' }: Cost and Headcount per OFO Code`;
        case ChartType.WSPCostAndHeadcountTrainingChart:
            return `WSP ${ scorecardYear}: Cost and Headcount per Training Type`;
        case ChartType.ATRCostAndHeadcountTrainingChart:
            return `ATR ${ scorecardYear ? scorecardYear - 1 : '' }: Cost and Headcount per Training Type`;
        case ChartType.WSPCostAndInterventionChart:
            return `WSP ${ scorecardYear }: Cost and Intervention Count per Funding Type`;
        case ChartType.ATRCostAndInterventionChart:
            return `ATR ${ scorecardYear ? scorecardYear - 1 : '' }: Cost and Intervention Count per Funding Type`;
        case ChartType.WorkforceProfileOfoMajorGroupSummary:
            return 'Workforce Profile per OFO Major Group';
        case ChartType.EEPlanTrackingChartAfricanMale:
            return `${raceGenderConfigs[0].race} ${raceGenderConfigs[0].gender} (${raceGenderConfigs[0].shortCode}) - Actual vs Plan`
        case ChartType.EEPlanTrackingChartAricanFemale:
            return `${raceGenderConfigs[1].race} ${raceGenderConfigs[1].gender} (${raceGenderConfigs[1].shortCode}) - Actual vs Plan`
        case ChartType.EEPlanTrackingChartColouredMale:
            return `${raceGenderConfigs[2].race} ${raceGenderConfigs[2].gender} (${raceGenderConfigs[2].shortCode}) - Actual vs Plan`
        case ChartType.EEPlanTrackingChartColouredFemale:
            return `${raceGenderConfigs[3].race} ${raceGenderConfigs[3].gender} (${raceGenderConfigs[3].shortCode}) - Actual vs Plan`
        case ChartType.EEPlanTrackingChartIndianMale:
            return `${raceGenderConfigs[4].race} ${raceGenderConfigs[4].gender} (${raceGenderConfigs[4].shortCode}) - Actual vs Plan`
        case ChartType.EEPlanTrackingChartIndianFemale:
            return `${raceGenderConfigs[5].race} ${raceGenderConfigs[5].gender} (${raceGenderConfigs[5].shortCode}) - Actual vs Plan`
        case ChartType.EEPlanTrackingChartWhiteMale:
            return `${raceGenderConfigs[6].race} ${raceGenderConfigs[6].gender} (${raceGenderConfigs[6].shortCode}) - Actual vs Plan`
        case ChartType.EEPlanTrackingChartWhiteFemale:
            return `${raceGenderConfigs[7].race} ${raceGenderConfigs[7].gender} (${raceGenderConfigs[7].shortCode}) - Actual vs Plan`
        case ChartType.EEPlanTrackingChartNonRSAMale:
            return `${raceGenderConfigs[8].race} ${raceGenderConfigs[8].gender} (${raceGenderConfigs[8].shortCode}) - Actual vs Plan`
        case ChartType.EEPlanTrackingChartNonRSAFemale:
            return `${raceGenderConfigs[9].race} ${raceGenderConfigs[9].gender} (${raceGenderConfigs[9].shortCode}) - Actual vs Plan`

    }
}
